import React from "react";
var __jsx = React.createElement;
/**
 * Else block for Conditional component
 */
export var Else = function Else(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};